import React from 'react';

const EmptyItemSelectionList = ({ message }: { message: string }) => (
  <div className="h-[30vh] flex flex-col items-center justify-center mt-6">
    <div className="relative">
      <div className="bg-[#EBEBEB] h-[80px] w-[80px] rounded-full" />
      <p className="text-[81px] -rotate-20 absolute -top-8 left-0">👥</p>
    </div>
    <p className="text-base font-normal mt-4"> {message}</p>
  </div>
);

export default EmptyItemSelectionList;
